/* MoodUp : comportements des sections mu-* (galerie, avis, offres, animations). Chaque section s'initialise seule,
   et se réinitialise dans l'éditeur de thème (shopify:section:load). */
(function () {
  if (window.__moodup) return; window.__moodup = 1;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (r, s) => r.querySelector(s), $$ = (r, s) => [...r.querySelectorAll(s)];
  const io = (el, fn, t = 0.35) => {
    if (!el) return;
    if (!('IntersectionObserver' in window)) return fn(el);
    const o = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { o.disconnect(); fn(el); } }), { threshold: t });
    o.observe(el);
  };
  const money = (cents, fmt) => {
    const v = (cents / 100).toFixed(2), [i, d] = v.split('.');
    const n = i.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ',' + d;
    return (fmt || '{{amount}} €').replace(/\{\{\s*amount[^}]*\}\}/, n);
  };

  const init = {
    gallery(root) {
      const tr = $(root, '.mu-gal-track'); if (!tr) return;
      const thumbs = $$(root, '.mu-thumbs button');
      const at = () => Math.round(tr.scrollLeft / tr.clientWidth);
      const go = i => tr.scrollTo({ left: Math.max(0, Math.min(tr.children.length - 1, i)) * tr.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      const mark = () => { const i = at(); thumbs.forEach((b, j) => b.setAttribute('aria-current', j === i)); const t = thumbs[i]; if (t) { const p = t.parentElement; p.scrollTo({ left: t.offsetLeft - p.clientWidth / 2 + t.offsetWidth / 2, behavior: 'smooth' }); } };
      thumbs.forEach((b, j) => b.addEventListener('click', () => go(j)));
      $(root, '.mu-arrow.l')?.addEventListener('click', () => go(at() - 1));
      $(root, '.mu-arrow.r')?.addEventListener('click', () => go(at() + 1));
      tr.addEventListener('scroll', () => { clearTimeout(tr._t); tr._t = setTimeout(mark, 80); }, { passive: true });
      mark();
    },
    reviews(root) {
      const row = $(root, '.mu-rv-row'); if (!row) return;
      const go = d => row.scrollBy({ left: d * row.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      $(root, '.mu-rvnav.l')?.addEventListener('click', () => go(-1));
      $(root, '.mu-rvnav.r')?.addEventListener('click', () => go(1));
      const modal = $(root, '.mu-modal');
      $$(root, '.mu-rvc').forEach(c => c.addEventListener('click', () => {
        if (!modal) return;
        const img = $(c, 'img');
        $(modal, 'img').src = img ? img.dataset.full || img.src : '';
        $(modal, 'img').hidden = !img;
        $(modal, '.mu-mtxt p').textContent = c.dataset.text || '';
        $(modal, '.mu-mtxt .who').textContent = c.dataset.who || '';
        modal.hidden = false;
      }));
      if (modal) {
        $(modal, '.mu-mclose').addEventListener('click', () => modal.hidden = true);
        modal.addEventListener('click', e => { if (e.target === modal) modal.hidden = true; });
        document.addEventListener('keydown', e => { if (e.key === 'Escape') modal.hidden = true; });
      }
    },
    offers(root) {
      const form = $(root, 'form.mu-form'); if (!form) return;
      const fmt = root.dataset.money, sticky = $(root, '.mu-sticky');
      // Date du jour (Paris) dans la ligne de stock, pour ne pas dépendre du cache de la page.
      const today = new Date().toLocaleDateString('fr-FR', { timeZone: 'Europe/Paris', day: 'numeric', month: 'long' }).replace(/ (\S)/, (_, c) => ' ' + c.toUpperCase());
      $$(root, '[data-today]').forEach(el => { el.textContent = today; });
      // Les offres viennent de Kaching : on lit le palier choisi pour Klarna et la barre du bas.
      const cents = s => { const m = (s || '').replace(/\s/g, '').match(/(\d+)(?:[.,](\d{2}))?/); return m ? +m[1] * 100 + +(m[2] || 0) : 0; };
      const put = (el, s) => { if (el && el.textContent !== s) el.textContent = s; };
      // Sans bloc d'appli Kaching dans l'éditeur, Kaching s'insère juste avant le formulaire :
      // on le remonte au-dessus de la ligne de stock pour garder l'ordre offres > stock > bouton.
      const place = () => {
        const kb = $(root, '.mu-buy > kaching-bundle'), st = kb && kb.previousElementSibling;
        if (st && st.classList.contains('mu-stock')) st.before(kb);
      };
      const upd = () => {
        place();
        const bar = $(root, '.kaching-bundles__bar--selected'); if (!bar) return;
        const price = cents($(bar, '.kaching-bundles__bar-price')?.textContent), title = $(bar, '.kaching-bundles__bar-title')?.textContent.trim() || '';
        if (!price) return;
        put($(root, '[data-klarna]'), money(Math.ceil(price / 3), fmt));
        if (sticky) put($(sticky, '[data-sticky-label]'), title + ' · ' + money(price, fmt));
      };
      new MutationObserver(upd).observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] }); upd();
      if (sticky) {
        $(sticky, 'button').addEventListener('click', () => $(form, '.mu-atc').click());
        const atc = $(form, '.mu-atc');
        const toggle = () => sticky.classList.toggle('on', atc.getBoundingClientRect().bottom < 40);
        addEventListener('scroll', toggle, { passive: true }); toggle();
      }
    },
    t530(root) {
      const el = $(root, '.mu-t530'); if (!el || reduce) return;
      const [h, m] = (el.dataset.time || '05:30').split(':');
      io(el, () => { let k = Math.max(0, +m - 3); const tick = () => { el.innerHTML = `${h}<span class="c">:</span>${String(k).padStart(2, '0')}`; if (k < +m) { k++; setTimeout(tick, 420); } else { el.classList.add('ring'); setTimeout(() => el.classList.remove('ring'), 1300); } }; tick(); });
    },
    kpis(root) {
      $$(root, '.mu-cell,.mu-ring').forEach(el => io(el, x => x.classList.add('go')));
      $$(root, '[data-count]').forEach(el => io(el, x => {
        if (reduce) return; const to = +x.dataset.count, suf = x.dataset.suf || '', st = performance.now();
        const step = n => { const k = Math.min(1, (n - st) / 1100); x.textContent = Math.round(to * (1 - Math.pow(1 - k, 3))) + suf; if (k < 1) requestAnimationFrame(step); };
        requestAnimationFrame(step);
      }, 0.5));
    },
    demo(root) {
      const bs = $$(root, '.mu-seg button'); if (!bs.length) return;
      bs.forEach(b => b.addEventListener('click', () => {
        bs.forEach(x => x.setAttribute('aria-pressed', x === b));
        const a = b.dataset.d === 'a';
        $(root, '[data-img="a"]').classList.toggle('off', !a);
        $(root, '[data-img="b"]').classList.toggle('off', a);
        $(root, '.mu-verdict').textContent = b.dataset.verdict || '';
      }));
    },
    levels(root) {
      const lv = $(root, '.mu-lv'); if (!lv) return;
      const rs = $$(lv, '.r'), band = $(lv, '.mu-lvband'), now = $(lv, '.now');
      let t = 0;
      const step = () => { const l = t % 4; rs.forEach((r, k) => { r.classList.toggle('on', k < l); $(r, 'i').style.width = k < l ? '100%' : '0'; }); if (band) band.className = 'mu-lvband' + (l ? ' l' + l : ''); if (now) now.textContent = (lv.dataset.time || '05:30') + ':' + String(l * 6).padStart(2, '0'); t++; };
      step();
      if (reduce) { rs.forEach(r => { r.classList.add('on'); $(r, 'i').style.width = '100%'; }); return; }
      clearInterval(lv._i); lv._i = setInterval(step, 1400);
    },
    tabs(root) {
      const bs = $$(root, '.mu-tabs button'), cards = $$(root, '.mu-who'); if (!bs.length) return;
      const sw = i => { bs.forEach((b, j) => b.setAttribute('aria-selected', j === i)); cards.forEach((c, j) => c.hidden = j !== i); };
      bs.forEach((b, i) => b.addEventListener('click', () => sw(i))); sw(0);
    },
    videos(root) {
      // Vidéos : miniature = 1re image, lecture sur place toujours en muet, bouton pour l'ouvrir en grand.
      const cards = $$(root, '.mu-vid[data-video]'); if (!cards.length) return;
      const getVideo = card => {
        let v = $(card, 'video');
        if (!v) { v = document.createElement('video'); v.className = 'mu-vthumb'; v.src = card.dataset.video; const img = $(card, 'img'); img ? img.replaceWith(v) : card.prepend(v); }
        v.muted = true; v.playsInline = true; v.loop = true;
        return v;
      };
      const stop = card => { const v = $(card, 'video'); if (v) v.pause(); card.classList.remove('playing'); };
      const toggle = card => {
        const v = getVideo(card);
        if (card.classList.contains('playing')) return stop(card);
        $$(document, '.mu-vid.playing').forEach(stop);
        v.play().catch(() => {}); card.classList.add('playing');
      };
      let modal = $(document, '.mu-vmodal');
      if (!modal) {
        modal = document.createElement('div'); modal.className = 'mu-vmodal'; modal.hidden = true;
        modal.innerHTML = '<div class="mu-vm-box" role="dialog" aria-modal="true" aria-label="Vidéo"><button type="button" class="mu-vm-close" aria-label="Fermer">×</button><video controls playsinline muted></video></div>';
        document.body.append(modal);
        const mv = $(modal, 'video'), close = () => { mv.pause(); modal.hidden = true; };
        $(modal, '.mu-vm-close').addEventListener('click', close);
        modal.addEventListener('click', e => { if (e.target === modal) close(); });
        document.addEventListener('keydown', e => { if (e.key === 'Escape' && !modal.hidden) close(); });
      }
      const open = card => {
        const cur = $(card, 'video'), t0 = cur ? cur.currentTime : 0; stop(card);
        const mv = $(modal, 'video'); mv.src = card.dataset.video; mv.muted = true;
        mv.addEventListener('loadedmetadata', () => { mv.currentTime = t0; }, { once: true });
        modal.hidden = false; mv.play().catch(() => {});
      };
      cards.forEach(card => {
        card.addEventListener('click', e => { if (e.target.closest('.mu-vexp')) { e.stopPropagation(); open(card); } else toggle(card); });
        card.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(card); } });
      });
    },
    story(root) {
      const sec = $(root, '.mu-story-sec'); if (!sec) return;
      const stage = $(sec, '.mu-stage'), panels = JSON.parse($(sec, 'script[type="application/json"]').textContent || '[]');
      const imgs = $$(sec, '.mu-simgs img'), dots = $$(sec, '.mu-snav i'), fd = $(sec, '.mu-sfade');
      let cur = -1;
      const set = i => {
        if (i === cur || !panels[i]) return; cur = i; const p = panels[i];
        stage.style.background = p.bg; stage.style.color = p.ink;
        imgs.forEach((im, j) => im.classList.toggle('on', j === i)); dots.forEach((d, j) => d.classList.toggle('on', j === i));
        fd.classList.add('out');
        setTimeout(() => {
          $(fd, '.num').textContent = String(i + 1).padStart(2, '0');
          $(fd, '.kick').textContent = p.kicker; $(fd, 'h2').textContent = p.title; $(fd, 'p').textContent = p.text;
          const ul = $(fd, 'ul'); ul.replaceChildren(...p.features.map(t => Object.assign(document.createElement('li'), { textContent: t })));
          fd.classList.remove('out');
        }, reduce ? 0 : 240);
      };
      const on = () => { const r = sec.getBoundingClientRect(), h = Math.max(1, r.height - stage.offsetHeight); const k = Math.max(0, Math.min(.999, -r.top / h)); set(Math.floor(k * panels.length)); };
      addEventListener('scroll', on, { passive: true }); addEventListener('resize', on); on();
    }
  };

  const run = root => Object.values(init).forEach(f => { try { f(root); } catch (e) { console.warn('[moodup]', e); } });
  const boot = () => document.querySelectorAll('.mu[data-mu]').forEach(el => { if (!el._mu) { el._mu = 1; run(el); } });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', e => { const el = e.target.querySelector('.mu[data-mu]'); if (el) { el._mu = 1; run(el); } });
})();
